import React from 'react';
import LoadingImage from '../../assets/images/logogif.gif';

const Loading = () => {
  return (
    <div style={{ width: "100%", height: "60vh", display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
      <img src={LoadingImage} width={300} style={{borderRadius:"50%"}} alt="Loading..." />
      <h4>Loading...</h4>
    </div>
  )
}

export default Loading;